export default "__VITE_ASSET__$yJDCPaP__"